angular
	.module('components.inicial')
	.factory('InicialService', InicialService);

InicialService.$inject = ['$http', 'URL_REST', 'URL_GEOSERVER'];

function InicialService($http, URL_REST, URL_GEOSERVER) {

	function buscarClientes() {
		// public eh o schema especifico e cliente eh uma tabela especifica
		return $http.get(URL_REST + 'schema/public/tabela/clientes');
	}

	function buscarSchemaTabelaColunaValor(schema, tabela, coluna, valor) {
		return $http.get(URL_REST + 'schema/' + schema + '/tabela/' + tabela + '/busca/' + coluna + '/' + valor);
	}

	function buscarDados(schema, tabela) {
		return $http.get(URL_REST + 'schema/' + schema + '/tabela/' + tabela);
	}

	function buscarTabelas(schema) {
		return $http.get(URL_REST + 'schema/' + schema + '/tabelas');
	}

	function buscarSchemas() {
		return $http.get(URL_REST + 'schemas/');
	}

	function buscarExtentBrasil() {
		// www.bboxfinder.com/
		return [-7651040.7832, -3199348.2559, -4402772.8292, 68487.5773]
	}

	function buscarWmsBrasil() {
		return new ol.layer.Image({
			source: new ol.source.ImageWMS({
				url: URL_GEOSERVER + 'BRASIL/wms',
				params: {
					'FORMAT': 'image/png',
					'VERSION': '1.1.1',
					'STYLES': '',
					'LAYERS': 'BRASIL:estados',
					'TILED': false
				},
				serverType: 'geoserver',
				crossOrigin: 'anonymous',
				transition: 1
			})
		});
	}

	return {
		buscarExtentBrasil: buscarExtentBrasil,
		buscarWmsBrasil: buscarWmsBrasil,
		buscarSchemas: buscarSchemas,
		buscarTabelas: buscarTabelas,
		buscarDados: buscarDados,
		buscarClientes: buscarClientes,
		buscarSchemaTabelaColunaValor: buscarSchemaTabelaColunaValor
	};
}
